import React from 'react'
import { getCookies, setCookie } from 'cookies-next'

export const CookieConsent = () => {
  const [visible, setVisible] = React.useState(false)

  React.useEffect(() => {
    // Проверяем, было ли уже дано согласие
    const consentGiven = getCookies().cookieConsent
    if (!consentGiven) {
      setVisible(true)
    }
  }, [])

  const handleAccept = () => {
    // Устанавливаем cookie с согласием на 1 год
    setCookie('cookieConsent', 'true', { maxAge: 60 * 60 * 24 * 365 })
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className='cookie-container'>
      <p className='cookie-text'>
        Пользуясь нашим сайтом, вы соглашаетесь с тем, что{' '}
        <a
          href='/policies/cookie-mitm.pdf'
          style={{ color: 'black' }}
          target='_blank'>
          мы используем cookies
        </a>
      </p>
      <button className='cookie-button' onClick={handleAccept} type='button'>
        Окей
      </button>
    </div>
  )
}
